import moment, { Moment } from 'moment';
import { Value } from '@philips-internal/oswald-ui-core';
import { LanguageService } from '@philips-internal/oswald-ui-core/lib/services';
import { SupportedLocale } from '@philips-internal/oswald-ui-constants';
import { DEFAULT_DATE_PATTERN, MONTH_YEAR_PATTERN, YEAR_PATTERN } from '../../../../constants/date-utils';

export default class HealthHistoryAllergiesCommons {

  public static getOnlyYear(date: Value | Moment): number {
    return (date && moment.isMoment(date)) ? date.year() : date as number;
  }

  public static handleUserLocale(): boolean {
    const userLocale       = LanguageService.getCurrentLanguage();
    const isUserLocalePtBr = userLocale === SupportedLocale.PT_BR;

    return isUserLocalePtBr;
  }

  public static getFormattedDateOrUndefined(date: any): string | undefined{
    return date ? this.getFormatDate(date, DEFAULT_DATE_PATTERN) : undefined;
  }

  public static getFormattedMonthOrUndefined(month: any): string | undefined{
    return month ? this.getFormatDate(month, MONTH_YEAR_PATTERN) : undefined;
  }

  public static getFormattedYearOrUndefined(year: any): string | undefined{
    return year ? this.getFormatDate(year, YEAR_PATTERN) : undefined;
  }

  private static getFormatDate(date: string, pattern: string): string {
    return moment(date).utc().format(pattern);
  }
}
